import { Observable } from "rxjs";

export class Select {
  id: number | null = null;
  label: string | null = null;
  labelLCode: string | null = null;

  static schema = {
    id: Number,
    label: String,
    labelLCode: String
  };

}

export class SelectMenu {
  id: number | null = null;
  label: string | null | Observable<string> = null;

  constructor(id: number | null, label: string | null |Observable<string>){
    this.id= id;
    this.label = label;
  }
}













